var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoPassport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6213 4.46522C30.7277 4.80333 30.7847 5.15976 30.7847 5.52786V20.2263C30.7847 21.0441 30.0462 21.707 29.1351 21.707H28.0353C28.0353 4.00193 28.0541 5.37077 27.9917 4.98108C27.7534 3.49206 30.164 3.01229 30.6213 4.46522Z",
    fill: "url(#paint0_linear_4402_12160)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2245 12.3674C13.8044 12.2254 13.7401 11.7124 14.1188 11.4915C15.7767 10.5251 15.2935 7.98096 12.958 7.98096C10.5983 7.98096 10.1471 10.5313 11.7944 11.4915C12.1709 11.7109 12.1114 12.2245 11.6888 12.3674C10.2308 12.8604 9.306 14.1425 9.36243 15.5135H16.5508C16.6073 14.1425 15.6825 12.8604 14.2245 12.3674Z",
    fill: "url(#paint1_linear_4402_12160)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2245 23.7995C13.8044 23.6574 13.7401 23.1444 14.1188 22.9236C15.7779 21.9565 15.2918 19.4131 12.958 19.4131C10.5983 19.4131 10.1471 21.9634 11.7944 22.9236C12.1709 23.143 12.1114 23.6566 11.6888 23.7995C10.2308 24.2925 9.306 25.5745 9.36243 26.9455H16.5508C16.6073 25.5746 15.6825 24.2926 14.2245 23.7995Z",
    fill: "url(#paint2_linear_4402_12160)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2791 26.9454V16.5005H6.63403V26.9454H8.26258C8.21508 25.431 9.08341 24.0041 10.5134 23.2206C8.83425 21.4917 9.88088 18.4257 12.958 18.4257C16.0011 18.4257 17.0934 21.4768 15.3997 23.2206C16.8297 24.0041 17.6981 25.4309 17.6506 26.9454H19.2791Z",
    fill: "url(#paint3_linear_4402_12160)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63403 15.5134H8.26258C8.21515 13.9991 9.08362 12.5722 10.5134 11.7886C8.83425 10.0597 9.88088 6.99376 12.958 6.99376C16.0011 6.99376 17.0933 10.0447 15.3997 11.7886C16.8297 12.5722 17.6981 13.9989 17.6505 15.5134H19.2791V5.60986H6.63403V15.5134Z",
    fill: "url(#paint4_linear_4402_12160)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2791 27.9326C17.7579 27.9326 23.8125 27.9326 6.63403 27.9326V31.2305H19.2791V27.9326Z",
    fill: "url(#paint5_linear_4402_12160)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63806 4.62254H19.2791V4.11723C19.2791 3.20422 19.597 2.32754 20.1621 1.61523H9.89343C8.14948 1.61523 6.7213 2.95063 6.63806 4.62254Z",
    fill: "url(#paint6_linear_4402_12160)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9754 2.10882C26.9754 1.83611 26.7294 1.61523 26.4255 1.61523H21.6473C20.8504 2.21303 20.3789 3.13598 20.3789 4.11723V31.2305H21.5164C22.4258 31.2305 23.1661 30.566 23.1661 29.7497V5.52815C23.1661 3.91473 24.6281 2.60241 26.4255 2.60241C26.7294 2.60241 26.9754 2.38153 26.9754 2.10882Z",
    fill: "url(#paint7_linear_4402_12160)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53428 4.77707C5.53428 3.51232 6.13269 2.37873 7.0734 1.61719C4.70224 1.65125 2.78467 3.39213 2.78467 5.5285V29.7501C2.78467 30.5663 3.52495 31.2308 4.43431 31.2308H5.53428V4.77707Z",
    fill: "url(#paint8_linear_4402_12160)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9355 5.52817V11.2538H24.2659V5.56395C24.2659 4.57616 25.0776 3.75557 26.1341 3.61182C26.6379 4.13502 26.9355 4.8137 26.9355 5.52817Z",
    fill: "url(#paint9_linear_4402_12160)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2659 12.2407H26.9355V21.7071H24.2659V12.2407Z",
    fill: "url(#paint10_linear_4402_12160)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_12160",
    x1: 29.38,
    y1: 3.58887,
    x2: 29.38,
    y2: 21.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_12160",
    x1: 12.9566,
    y1: 7.98096,
    x2: 12.9566,
    y2: 15.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_12160",
    x1: 12.9566,
    y1: 19.4131,
    x2: 12.9566,
    y2: 26.9455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4402_12160",
    x1: 12.9566,
    y1: 16.5005,
    x2: 12.9566,
    y2: 26.9454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4402_12160",
    x1: 12.9565,
    y1: 5.60986,
    x2: 12.9565,
    y2: 15.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4402_12160",
    x1: 12.9566,
    y1: 27.9326,
    x2: 12.9566,
    y2: 31.2305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4402_12160",
    x1: 13.4001,
    y1: 1.61523,
    x2: 13.4001,
    y2: 4.62254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4402_12160",
    x1: 23.6772,
    y1: 1.61523,
    x2: 23.6772,
    y2: 31.2305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4402_12160",
    x1: 4.92904,
    y1: 1.61719,
    x2: 4.92904,
    y2: 31.2308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4402_12160",
    x1: 25.6007,
    y1: 3.61182,
    x2: 25.6007,
    y2: 11.2538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4402_12160",
    x1: 25.6007,
    y1: 12.2407,
    x2: 25.6007,
    y2: 21.7071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPassport);
export default __webpack_public_path__ + "static/media/Photo Passport.899de8930533ff163bed2d189d160a99.svg";
export { ForwardRef as ReactComponent };